<div class="border">
    <div class="info-text">
        <xm-media-image class="image" [staticImagePath]="imagePath" [imageSource]="'buy_static_base_url'" [staticImageAlt]="imageAlt"></xm-media-image>
        <span class="message" [innerHTML]="statusMessage"></span>
    </div>
</div>